export default "__VITE_ASSET__Dm8xbodw__"